export interface NotificationSetting {
  id: number;
  label: string;
  push: boolean;
  sms: boolean;
  mandatory: boolean;
}

export const notificationSettings: NotificationSetting[] = [
  { id: 1, label: "طلب جديد", push: true, sms: true, mandatory: true },
  { id: 2, label: "طلب ملغي", push: true, sms: false, mandatory: false },
  { id: 3, label: "تقييم جديد", push: true, sms: false, mandatory: false },
  { id: 4, label: "تقييم سلبي (1-2★)", push: true, sms: true, mandatory: false },
  { id: 5, label: "تسوية مالية جاهزة", push: true, sms: true, mandatory: false },
  { id: 6, label: "غرامة جديدة", push: true, sms: true, mandatory: true },
];

export interface TeamUser {
  id: number;
  name: string;
  email: string;
  role: string;
  status: string;
  isMe?: boolean;
}

export const teamUsers: TeamUser[] = [
  { id: 1, name: "أحمد محمد", email: "ahmed@almaya.sa", role: "مدير", status: "نشط", isMe: true },
  { id: 2, name: "سارة العلي", email: "sara@almaya.sa", role: "مشرف طلبات", status: "نشط" },
  { id: 3, name: "خالد المطيري", email: "khaled@almaya.sa", role: "محاسب", status: "نشط" },
];

export const roles = [
  { name: "مدير", desc: "كل الصلاحيات — الوحيد اللي يعدّل الحساب البنكي" },
  { name: "مشرف طلبات", desc: "يدير الطلبات + يسند للفرق + يرد على التقييمات" },
  { name: "محاسب", desc: "يشوف التقارير والتسويات فقط" },
  { name: "عارض", desc: "يشوف كل شي بدون تعديل" },
];

export const banks = ["مصرف الراجحي", "البنك الأهلي", "مصرف الإنماء", "بنك الرياض", "البنك السعودي الفرنسي"];